// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend-step-shapes` to regenerate.
// Typescript is intentionally enabled for this file, since the types are used by the Analysis Tool.
// If autogeneration causes a type error, strongly prefer fixing the underlying issue over disabling
// typescript.
// For debugging: the file is generated via scripts/pipelines/generate_frontend_step_shapes.py

import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const PIPELINE_STEP_SHAPES = {
  [PipelineStepType.AGGREGATE_DATASET]: [
    {
      stepType: PipelineStepType.AGGREGATE_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        groupColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          }
        },
        aggregations: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'taggedUnion',
            required: true,
            tagKey: 'aggregationFunction',
            choices: [
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'AVERAGE'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'COUNT'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'COUNT_NULLS'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'MAX'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'MEDIAN'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'MIN'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'MODE'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'PRODUCT'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'STANDARD_DEVIATION'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'STANDARD_ERROR'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'SUM'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'VARIANCE'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'GEOMETRIC_MEAN'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'STRING_AGG'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  separator: {
                    kind: 'string',
                    required: true
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  }
                }
              }
            ]
          },
          minItems: 1
        }
      }
    }
  ],
  [PipelineStepType.ANOVA]: [
    {
      stepType: PipelineStepType.ANOVA,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        dataFormat: {
          kind: 'taggedUnion',
          required: true,
          tagKey: 'type',
          choices: [
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'LONG'
                },
                labelColumn: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                valueColumn: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                labelsToUse: {
                  kind: 'array',
                  required: false,
                  elementSpec: {
                    kind: 'string',
                    required: true
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'WIDE'
                },
                columns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  minItems: 1
                }
              }
            }
          ]
        },
        significanceLevel: {
          kind: 'number',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.BIN_DATA]: [
    {
      stepType: PipelineStepType.BIN_DATA,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        column: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          validationOptions: {
            allowedLeafTypes: [
              LeafType.INTEGER,
              LeafType.DECIMAL,
              LeafType.DATE,
              LeafType.DATETIME
            ]
          }
        },
        numBins: {
          kind: 'integer',
          required: false,
          minValue: 1,
          maxValue: 1000
        }
      }
    }
  ],
  [PipelineStepType.CHAI1]: [
    {
      stepType: PipelineStepType.CHAI1,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input FASTA': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Predicted structure': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        },
        'Prediction metadata': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: false
        }
      },
      config: {}
    }
  ],
  [PipelineStepType.CHART_VIEW]: [
    {
      stepType: PipelineStepType.CHART_VIEW,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Sampled output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: false
        },
        'Output chart': {
          kind: PipelineStepDataKind.CHART,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        chartConfig: {
          kind: 'taggedUnion',
          required: true,
          tagKey: 'type',
          choices: [
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'BAR_CHART'
                },
                parameters: {
                  kind: 'shape',
                  required: true,
                  fields: {
                    barChartType: {
                      kind: 'enum',
                      required: true,
                      choices: [
                        'STANDARD',
                        'STACKED'
                      ]
                    },
                    seriesColumnName: {
                      kind: 'columnReference',
                      required: false,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    sortDirection: {
                      kind: 'enum',
                      required: false,
                      choices: [
                        'ASCENDING',
                        'DESCENDING'
                      ]
                    },
                    tryConvertStrings: {
                      kind: 'boolean',
                      required: false
                    },
                    xAxisColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    yAxisColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    yAxisMin: {
                      kind: 'number',
                      required: false
                    },
                    yAxisMax: {
                      kind: 'number',
                      required: false
                    },
                    yAxisScale: {
                      kind: 'enum',
                      required: true,
                      choices: [
                        'LINEAR',
                        'LOG'
                      ]
                    },
                    errorBarColumnName: {
                      kind: 'columnReference',
                      required: false,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'BOX_PLOT'
                },
                parameters: {
                  kind: 'shape',
                  required: true,
                  fields: {
                    xAxisColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    xAxisLabel: {
                      kind: 'string',
                      required: false
                    },
                    xAxisMin: {
                      kind: 'number',
                      required: false
                    },
                    xAxisMax: {
                      kind: 'number',
                      required: false
                    },
                    sortDirection: {
                      kind: 'enum',
                      required: false,
                      choices: [
                        'ASCENDING',
                        'DESCENDING'
                      ]
                    },
                    pointLabelColumnName: {
                      kind: 'columnReference',
                      required: false,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    yAxisColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    yAxisLabel: {
                      kind: 'string',
                      required: false
                    },
                    yAxisMin: {
                      kind: 'number',
                      required: false
                    },
                    yAxisMax: {
                      kind: 'number',
                      required: false
                    },
                    invertYAxis: {
                      kind: 'boolean',
                      required: false
                    },
                    seriesColumnName: {
                      kind: 'columnReference',
                      required: false,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    showPoints: {
                      kind: 'enum',
                      required: true,
                      choices: [
                        'ALL',
                        'OUTLIERS',
                        'HIDE'
                      ]
                    },
                    showLegend: {
                      kind: 'boolean',
                      required: true
                    },
                    legendLabel: {
                      kind: 'string',
                      required: false
                    },
                    legendLocation: {
                      kind: 'enum',
                      required: false,
                      choices: [
                        'LEFT',
                        'RIGHT',
                        'TOP'
                      ]
                    }
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'CONTOUR_PLOT'
                },
                parameters: {
                  kind: 'shape',
                  required: true,
                  fields: {
                    colorScale: {
                      kind: 'enum',
                      required: false,
                      choices: [
                        'BLUE',
                        'BLUE_LIME',
                        'LAVA'
                      ]
                    },
                    gradientDirection: {
                      kind: 'enum',
                      required: false,
                      choices: [
                        'ASCENDING_METRIC_VALUES',
                        'DESCENDING_METRIC_VALUES'
                      ]
                    },
                    metricColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    scatterChartConfig: {
                      kind: 'shape',
                      required: false,
                      fields: {
                        colorPalette: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'DISCRETE',
                            'GRADIENT'
                          ]
                        },
                        legendLocation: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'LEFT',
                            'RIGHT',
                            'TOP'
                          ]
                        },
                        seriesColumnName: {
                          kind: 'columnReference',
                          required: false,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        seriesColorConfigs: {
                          kind: 'array',
                          required: false,
                          elementSpec: {
                            kind: 'shape',
                            required: true,
                            fields: {
                              seriesValue: {
                                kind: 'anything',
                                required: true
                              },
                              color: {
                                kind: 'enum',
                                required: false,
                                choices: [
                                  'WHITE',
                                  'BLACK',
                                  'GREEN'
                                ]
                              },
                              borderColor: {
                                kind: 'enum',
                                required: false,
                                choices: [
                                  'WHITE',
                                  'BLACK',
                                  'GREEN'
                                ]
                              }
                            }
                          }
                        },
                        seriesShapeConfigs: {
                          kind: 'array',
                          required: false,
                          elementSpec: {
                            kind: 'shape',
                            required: true,
                            fields: {
                              seriesValue: {
                                kind: 'anything',
                                required: true
                              },
                              borderWidth: {
                                kind: 'integer',
                                required: false
                              },
                              markerShape: {
                                kind: 'enum',
                                required: false,
                                choices: [
                                  'CIRCLE',
                                  'DIAMOND'
                                ]
                              },
                              markerSize: {
                                kind: 'integer',
                                required: false
                              }
                            }
                          }
                        },
                        tryConvertStrings: {
                          kind: 'boolean',
                          required: false
                        },
                        xAxisColumnName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        xAxisScale: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'LINEAR',
                            'LOG'
                          ]
                        },
                        yAxisColumnName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        yAxisIncludesZero: {
                          kind: 'boolean',
                          required: true
                        },
                        yAxisMin: {
                          kind: 'number',
                          required: false
                        },
                        yAxisMax: {
                          kind: 'number',
                          required: false
                        },
                        yAxisScale: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'LINEAR',
                            'LOG'
                          ]
                        }
                      }
                    },
                    xAxisColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    yAxisColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    showLegend: {
                      kind: 'boolean',
                      required: true
                    },
                    legendLabel: {
                      kind: 'string',
                      required: false
                    },
                    legendLocation: {
                      kind: 'enum',
                      required: false,
                      choices: [
                        'LEFT',
                        'RIGHT',
                        'TOP'
                      ]
                    }
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'HEATMAP'
                },
                parameters: {
                  kind: 'shape',
                  required: true,
                  fields: {
                    gradientDirection: {
                      kind: 'enum',
                      required: true,
                      choices: [
                        'ASCENDING_METRIC_VALUES',
                        'DESCENDING_METRIC_VALUES'
                      ]
                    },
                    metricColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    tryConvertStrings: {
                      kind: 'boolean',
                      required: false
                    },
                    xAxisColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    yAxisColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'LINE_CHART'
                },
                parameters: {
                  kind: 'shape',
                  required: true,
                  fields: {
                    seriesColumnName: {
                      kind: 'columnReference',
                      required: false,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    tryConvertStrings: {
                      kind: 'boolean',
                      required: false
                    },
                    xAxisColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    xAxisScale: {
                      kind: 'enum',
                      required: true,
                      choices: [
                        'LINEAR',
                        'LOG'
                      ]
                    },
                    yAxisColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    yAxisIncludesZero: {
                      kind: 'boolean',
                      required: true
                    },
                    yAxisScale: {
                      kind: 'enum',
                      required: true,
                      choices: [
                        'LINEAR',
                        'LOG'
                      ]
                    },
                    errorBarColumnName: {
                      kind: 'columnReference',
                      required: false,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'SCATTER_PLOT'
                },
                parameters: {
                  kind: 'shape',
                  required: true,
                  fields: {
                    colorPalette: {
                      kind: 'enum',
                      required: true,
                      choices: [
                        'DISCRETE',
                        'GRADIENT'
                      ]
                    },
                    legendLocation: {
                      kind: 'enum',
                      required: false,
                      choices: [
                        'LEFT',
                        'RIGHT',
                        'TOP'
                      ]
                    },
                    seriesColumnName: {
                      kind: 'columnReference',
                      required: false,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    seriesColorConfigs: {
                      kind: 'array',
                      required: false,
                      elementSpec: {
                        kind: 'shape',
                        required: true,
                        fields: {
                          seriesValue: {
                            kind: 'anything',
                            required: true
                          },
                          color: {
                            kind: 'enum',
                            required: false,
                            choices: [
                              'WHITE',
                              'BLACK',
                              'GREEN'
                            ]
                          },
                          borderColor: {
                            kind: 'enum',
                            required: false,
                            choices: [
                              'WHITE',
                              'BLACK',
                              'GREEN'
                            ]
                          }
                        }
                      }
                    },
                    seriesShapeConfigs: {
                      kind: 'array',
                      required: false,
                      elementSpec: {
                        kind: 'shape',
                        required: true,
                        fields: {
                          seriesValue: {
                            kind: 'anything',
                            required: true
                          },
                          borderWidth: {
                            kind: 'integer',
                            required: false
                          },
                          markerShape: {
                            kind: 'enum',
                            required: false,
                            choices: [
                              'CIRCLE',
                              'DIAMOND'
                            ]
                          },
                          markerSize: {
                            kind: 'integer',
                            required: false
                          }
                        }
                      }
                    },
                    tryConvertStrings: {
                      kind: 'boolean',
                      required: false
                    },
                    xAxisColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    xAxisScale: {
                      kind: 'enum',
                      required: true,
                      choices: [
                        'LINEAR',
                        'LOG'
                      ]
                    },
                    yAxisColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    yAxisIncludesZero: {
                      kind: 'boolean',
                      required: true
                    },
                    yAxisMin: {
                      kind: 'number',
                      required: false
                    },
                    yAxisMax: {
                      kind: 'number',
                      required: false
                    },
                    yAxisScale: {
                      kind: 'enum',
                      required: true,
                      choices: [
                        'LINEAR',
                        'LOG'
                      ]
                    },
                    errorBarColumnName: {
                      kind: 'columnReference',
                      required: false,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'PIE_CHART'
                },
                parameters: {
                  kind: 'shape',
                  required: true,
                  fields: {
                    legendLocation: {
                      kind: 'enum',
                      required: false,
                      choices: [
                        'LEFT',
                        'RIGHT',
                        'TOP'
                      ]
                    },
                    measureColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    showPercentageInLabel: {
                      kind: 'boolean',
                      required: true
                    },
                    showSliceNameInLabel: {
                      kind: 'boolean',
                      required: true
                    },
                    showValueInLabel: {
                      kind: 'boolean',
                      required: true
                    },
                    sliceColumnName: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    },
                    tryConvertStrings: {
                      kind: 'boolean',
                      required: false
                    }
                  }
                }
              }
            }
          ]
        },
        chartName: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.COMPUTED_COLUMN]: [
    {
      stepType: PipelineStepType.COMPUTED_COLUMN,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        formula: {
          kind: 'shape',
          required: true,
          fields: {
            formulaText: {
              kind: 'string',
              required: true
            },
            formulaAst: {
              kind: 'taggedUnion',
              required: true,
              tagKey: 'type',
              choices: [
                {
                  kind: 'shape',
                  required: true,
                  fields: {
                    type: {
                      kind: 'string',
                      required: true,
                      value: 'COLUMN_REFERENCE'
                    },
                    value: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  }
                },
                {
                  kind: 'shape',
                  required: true,
                  fields: {
                    type: {
                      kind: 'string',
                      required: true,
                      value: 'STRING_LITERAL'
                    },
                    value: {
                      kind: 'string',
                      required: true
                    }
                  }
                },
                {
                  kind: 'shape',
                  required: true,
                  fields: {
                    type: {
                      kind: 'string',
                      required: true,
                      value: 'NUMBER_LITERAL'
                    },
                    value: {
                      kind: 'number',
                      required: true
                    }
                  }
                },
                {
                  kind: 'shape',
                  required: true,
                  fields: {
                    type: {
                      kind: 'string',
                      required: true,
                      value: 'BOOLEAN_LITERAL'
                    },
                    value: {
                      kind: 'boolean',
                      required: true
                    }
                  }
                },
                {
                  kind: 'shape',
                  required: true,
                  fields: {
                    type: {
                      kind: 'string',
                      required: true,
                      value: 'OPERATION'
                    },
                    operation: {
                      kind: 'enum',
                      required: true,
                      choices: [
                        'ABSOLUTE_VALUE',
                        'ADD',
                        'AND',
                        'AVERAGE',
                        'CEILING',
                        'CONTAINS',
                        'COUNT',
                        'COUNT_BLANKS',
                        'DATE_CONVERT',
                        'DATE_DIFF',
                        'DATE_TRUNC',
                        'DATE_TRUNC_INTERVAL',
                        'DIVIDE',
                        'EQUALS',
                        'EXP',
                        'EXTRACT',
                        'FACTORIAL',
                        'FLOOR',
                        'GEOMETRIC_MEAN',
                        'GREATER_THAN',
                        'GREATER_THAN_OR_EQUALS',
                        'IF',
                        'IS_BLANK',
                        'LEFT',
                        'LENGTH',
                        'LESS_THAN',
                        'LESS_THAN_OR_EQUALS',
                        'LOG_10',
                        'LOG_2',
                        'MAX',
                        'MEDIAN',
                        'MIN',
                        'MODE',
                        'MODULUS',
                        'MULTIPLY',
                        'NATURAL_LOG',
                        'NOT_EQUALS',
                        'NULL_VALUE',
                        'OR',
                        'PI',
                        'POWER',
                        'PRODUCT',
                        'RIGHT',
                        'ROUND',
                        'SPLIT',
                        'STANDARD_DEVIATION',
                        'STANDARD_ERROR',
                        'SUBSTITUTE',
                        'SUBSTRING',
                        'SUBTRACT',
                        'SUM',
                        'TEXT_JOIN',
                        'VARIANCE',
                        'VLOOKUP'
                      ]
                    },
                    arguments: {
                      kind: 'array',
                      required: true,
                      elementSpec: {
                        kind: 'anything',
                        required: true
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        newColumnName: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.CONNECTION_DATA_DATASET]: [
    {
      stepType: PipelineStepType.CONNECTION_DATA_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {},
      outputDataShapes: {
        Dataset: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        dataFrameName: {
          kind: 'string',
          required: true
        },
        connectionId: {
          kind: 'string',
          required: true
        },
        connectionFileId: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.CONVERT_ASM_TO_CSV]: [
    {
      stepType: PipelineStepType.CONVERT_ASM_TO_CSV,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        transformType: {
          kind: 'enum',
          required: true,
          choices: [
            'Allotrope',
            'Analyte',
            'Compensation',
            'Datacube',
            'Fractions',
            'Group',
            'Injections',
            'Log',
            'Measurement',
            'Measurement Separate Unit Column',
            'Original',
            'Peaks',
            'Processed',
            'Population',
            'Region',
            'Report Point',
            'Report',
            'Sample',
            'Sample Separate Unit Column',
            'Statistics',
            'Timeseries',
            'Well'
          ]
        }
      }
    }
  ],
  [PipelineStepType.CONVERT_JSON_TO_DATASET]: [
    {
      stepType: PipelineStepType.CONVERT_JSON_TO_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        Dataset: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        name: {
          kind: 'string',
          required: true
        },
        columns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              name: {
                kind: 'string',
                required: true
              },
              path: {
                kind: 'string',
                required: true
              },
              include: {
                kind: 'boolean',
                required: true
              },
              required: {
                kind: 'boolean',
                required: true
              }
            }
          },
          minItems: 1
        }
      }
    }
  ],
  [PipelineStepType.CONVERT_TO_ASM]: [
    {
      stepType: PipelineStepType.CONVERT_TO_ASM,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        asmVendor: {
          kind: 'enum',
          required: true,
          choices: [
            'Agilent Gen5',
            'Agilent Gen5 Image',
            'Agilent OpenLab CDS',
            'Agilent TapeStation Analysis',
            'AppBio AbsoluteQ',
            'AppBio QuantStudio RT-PCR',
            'AppBio QuantStudio Design & Analysis',
            'Benchling Waters Empower Adapter',
            'Beckman Coulter Biomek',
            'Beckman Echo Plate Reformat',
            'BMG Labtech SMART Control',
            'BMG Labtech MARS',
            'Beckman Coulter PharmSpec',
            'Beckman Coulter Vi-Cell BLU',
            'Beckman Coulter Vi-Cell XR',
            'BD Biosciences FACSDiva',
            'Bio-Rad Bio-Plex Manager',
            'Bio-Rad CFX Maestro',
            'ChemoMetec NC View',
            'ChemoMetec Nucleoview',
            'CTL ImmunoSpot',
            'Cytiva Biacore T200 Control',
            'Cytiva Unicorn',
            'FlowJo',
            'Luminex INTELLIFLEX',
            'Luminex xPONENT',
            'Mabtech Apex',
            'MSD Methodical Mind',
            'Molecular Devices SoftMax Pro',
            'MSD Discovery Workbench',
            'Revvity Matrix',
            'NovaBio Flex2',
            'PerkinElmer Envision',
            'Qiacuity dPCR',
            'Revvity Kaleido',
            'Roche Cedex BioHT',
            'Roche Cedex HiRes',
            'Tecan Magellan',
            'Benchling Thermo Fisher Scientific Chromeleon',
            'Thermo Fisher Scientific Genesys30',
            'Thermo Fisher Scientific Genesys On-Board',
            'Thermo Fisher Scientific NanoDrop 8000',
            'Thermo Fisher Scientific NanoDrop Eight',
            'Thermo Fisher Scientific Nanodrop One',
            'Thermo Fisher Scientific Qubit 4',
            'Thermo Fisher Scientific Qubit Flex',
            'Thermo Fisher Scientific VISIONlite',
            'Thermo Fisher Scientific SkanIt',
            'Unchained Labs Lunatic'
          ]
        }
      }
    }
  ],
  [PipelineStepType.CREATE_DATASET_FROM_FILE]: [
    {
      stepType: PipelineStepType.CREATE_DATASET_FROM_FILE,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        Dataset: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        datasetName: {
          kind: 'string',
          required: true
        },
        csvDelimiter: {
          kind: 'enum',
          required: true,
          choices: [
            'Comma (`,`)',
            'Space (` `)',
            'Tab (`\u00a0\u00a0\u00a0\u00a0`)',
            'Pipe (`|`)',
            'Custom value'
          ]
        },
        customCsvDelimiter: {
          kind: 'string',
          required: false
        },
        dataLocale: {
          kind: 'enum',
          required: true,
          choices: [
            'International (12 hour)',
            'International (24 hour)',
            'Afrikaans',
            'Afrikaans (Namibia)',
            'Afrikaans (South Africa)',
            'Akan',
            'Albanian',
            'Albanian (Regional)',
            'Arabic',
            'Arabic (Morocco)',
            'Arabic (Regional)',
            'Arabic (Saudi Arabia)',
            'Armenian',
            'Azerbaijani',
            'Azerbaijani (Regional)',
            'Basque',
            'Basque (Regional)',
            'Belarusian',
            'Bengali',
            'Bengali (Bangladesh)',
            'Bengali (India)',
            'Bosnian',
            'Bulgarian',
            'Bulgarian (Regional)',
            'Burmese',
            'Catalan',
            'Catalan (Regional)',
            'Chinese',
            'Chinese Simplified',
            'Chinese Simplified (China)',
            'Chinese Simplified (Singapore)',
            'Chinese Traditional',
            'Chinese Traditional (Hong Kong)',
            'Chinese Traditional (Taiwan)',
            'Croatian',
            'Croatian (Regional)',
            'Czech',
            'Czech (Regional)',
            'Danish',
            'Danish (Regional)',
            'Dutch',
            'Dutch (Belgium)',
            'Dutch (Netherlands)',
            'English',
            'English (Australia)',
            'English (Canada)',
            'English (India)',
            'English (Ireland)',
            'English (South Africa)',
            'English (UK)',
            'English (US)',
            'Esperanto',
            'Esperanto (Regional)',
            'Estonian',
            'Estonian (Estonia)',
            'Faroese',
            'Filipino',
            'Filipino (Regional)',
            'Finnish',
            'Finnish (Regional)',
            'French',
            'French (Belgium)',
            'French (Canada)',
            'French (France)',
            'French (Switzerland)',
            'Frisian (West)',
            'Fulah',
            'Galician',
            'Galician (Regional)',
            'Georgian',
            'German',
            'German (Austria)',
            'German (Germany)',
            'German (Switzerland)',
            'Greek',
            'Greek (Greece)',
            'Gujarati',
            'Hebrew',
            'Hebrew (Regional)',
            'Hindi',
            'Hindi (Regional)',
            'Hungarian',
            'Hungarian (Regional)',
            'Icelandic',
            'Icelandic (Iceland)',
            'Indonesian',
            'Indonesian (Regional)',
            'Irish',
            'Irish (Gaelic)',
            'Italian',
            'Italian (Regional)',
            'Japanese',
            'Japanese (Regional)',
            'Javanese',
            'Kabyle',
            'Kannada',
            'Kannada (India)',
            'Kazakh',
            'Khmer',
            'Khmer (Regional)',
            'Korean',
            'Korean (Korea)',
            'Kurdish',
            'Latin',
            'Latvian',
            'Latvian (Regional)',
            'Lithuanian',
            'Lithuanian (Regional)',
            'Lower Sorbian',
            'Luxembourgish',
            'Macedonian',
            'Macedonian (Macedonian)',
            'Maithili',
            'Malagasy',
            'Malay',
            'Malay (Regional)',
            'Malayalam',
            'Malayalam (Regional)',
            'Maltese',
            'Maltese (Regional)',
            'Marathi',
            'Marathi (Regional)',
            'Mongolian',
            'Nepali',
            'Nepali (Regional)',
            'Northern S\u00e1mi',
            'Norwegian',
            'Norwegian (bokmal)',
            'Norwegian (bokmal) (Regional)',
            'Norwegian (nynorsk)',
            'Oriya',
            'Pashto',
            'Persian',
            'Persian (Regional)',
            'Polish',
            'Polish (Regional)',
            'Portuguese',
            'Portuguese (Brazil)',
            'Portuguese (Portugal)',
            'Punjabi',
            'Punjabi (India)',
            'Quechua',
            'Romanian',
            'Romanian (Regional)',
            'Romansh',
            'Russian',
            'Russian (Regional)',
            'Sanskrit',
            'Serbian',
            'Serbian (Serbia)',
            'Sinhala (Sri Lanka)',
            'Slovak',
            'Slovak (Slovakia)',
            'Slovenian',
            'Slovenian (Regional)',
            'Somali',
            'Spanish',
            'Spanish (Argentina)',
            'Spanish (Chile)',
            'Spanish (Colombia)',
            'Spanish (Ecuador)',
            'Spanish (Latin America) (es-419)',
            'Spanish (Latin America) (es-LA)',
            'Spanish (Mexico)',
            'Spanish (Nicaragua)',
            'Spanish (Spain)',
            'Spanish (United States)',
            'Spanish (Venezuela)',
            'Sundanese',
            'Swahili',
            'Swahili (Kenya)',
            'Swedish',
            'Swedish (Regional)',
            'Tajik',
            'Tajik (Regional)',
            'Tamil',
            'Tamil (Regional)',
            'Tatar',
            'Telugu',
            'Telugu (Regional)',
            'Thai',
            'Thai (Thailand)',
            'Turkish',
            'Turkish (Regional)',
            'Ukrainian',
            'Ukrainian (Regional)',
            'Upper Sorbian',
            'Urdu',
            'Urdu (Regional)',
            'Uzbek',
            'Uzbek (Regional)',
            'Vietnamese',
            'Vietnamese (Regional)',
            'Welsh',
            'Welsh (Regional)',
            'Xhosa',
            'Yiddish',
            'Zulu'
          ]
        },
        sheetName: {
          kind: 'string',
          required: false
        }
      }
    }
  ],
  [PipelineStepType.DATA_CATALOG_DATASET]: [
    {
      stepType: PipelineStepType.DATA_CATALOG_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {},
      outputDataShapes: {
        Dataset: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        datasetId: {
          kind: 'string',
          required: true
        },
        dataFrameName: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.DATA_CATALOG_FILE]: [
    {
      stepType: PipelineStepType.DATA_CATALOG_FILE,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {},
      outputDataShapes: {
        File: {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        fileId: {
          kind: 'string',
          required: true
        },
        fileName: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.DATASET_VIEW]: [
    {
      stepType: PipelineStepType.DATASET_VIEW,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {}
    }
  ],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_BOOTSTRAP]: [
    {
      stepType: PipelineStepType.EXPERIMENT_OPTIMIZATION_BOOTSTRAP,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Model file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Bootstrap model file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        targetColumn: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          validationOptions: {
            allowedLeafTypes: [
              LeafType.INTEGER,
              LeafType.DECIMAL
            ]
          }
        }
      }
    }
  ],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_CLEAN_DATA]: [
    {
      stepType: PipelineStepType.EXPERIMENT_OPTIMIZATION_CLEAN_DATA,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        targetColumn: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          validationOptions: {
            allowedLeafTypes: [
              LeafType.INTEGER,
              LeafType.DECIMAL
            ]
          }
        },
        groupingColumn: {
          kind: 'columnReference',
          required: false,
          inputDataName: 'Input dataset',
          validationOptions: null
        },
        featureColumns: {
          kind: 'array',
          required: false,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          }
        },
        excludedColumns: {
          kind: 'array',
          required: false,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          }
        }
      }
    }
  ],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_EXPLANATION]: [
    {
      stepType: PipelineStepType.EXPERIMENT_OPTIMIZATION_EXPLANATION,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Model file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Feature importance': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Prediction explanations': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        targetColumn: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          validationOptions: {
            allowedLeafTypes: [
              LeafType.INTEGER,
              LeafType.DECIMAL
            ]
          }
        },
        groupingColumn: {
          kind: 'columnReference',
          required: false,
          inputDataName: 'Input dataset',
          validationOptions: null
        }
      }
    }
  ],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE]: [
    {
      stepType: PipelineStepType.EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Categorical design space': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Continuous design space': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Search space': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        categoricalDesignSpace: {
          kind: 'tableReference',
          required: false,
          inputDataName: 'Categorical design space',
          inputDataIndex: 0
        },
        continuousDesignSpace: {
          kind: 'tableReference',
          required: false,
          inputDataName: 'Continuous design space',
          inputDataIndex: 0
        }
      }
    }
  ],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY]: [
    {
      stepType: PipelineStepType.EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Training dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Search space dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Recommendations dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Model file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Posterior summary dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Contour plots dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {}
    }
  ],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_RECOMMENDATION]: [
    {
      stepType: PipelineStepType.EXPERIMENT_OPTIMIZATION_RECOMMENDATION,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Training dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Search space dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Model file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Recommendations dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        numRecommendations: {
          kind: 'integer',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_TRAINING]: [
    {
      stepType: PipelineStepType.EXPERIMENT_OPTIMIZATION_TRAINING,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Training dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Model file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        },
        'Model performance': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Model predictions': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Model comparison': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Categorical design space': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Continuous design space': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        targetColumn: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          validationOptions: {
            allowedLeafTypes: [
              LeafType.INTEGER,
              LeafType.DECIMAL
            ]
          }
        },
        groupingColumn: {
          kind: 'columnReference',
          required: false,
          inputDataName: 'Input dataset',
          validationOptions: null
        }
      }
    }
  ],
  [PipelineStepType.EXPLORATORY_DATA_ANALYSIS]: [
    {
      stepType: PipelineStepType.EXPLORATORY_DATA_ANALYSIS,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Continuous summary table': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Categorical summary table': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Input table': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Correlation coefficient table': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Distribution histograms': {
          kind: PipelineStepDataKind.CHART,
          isMulti: true,
          isRequired: false
        },
        'Correlation charts between X': {
          kind: PipelineStepDataKind.CHART,
          isMulti: true,
          isRequired: false
        },
        'Correlation charts between X and Y': {
          kind: PipelineStepDataKind.CHART,
          isMulti: true,
          isRequired: false
        },
        'Additional charts': {
          kind: PipelineStepDataKind.CHART,
          isMulti: true,
          isRequired: false
        }
      },
      config: {
        labelColumn: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          validationOptions: {
            allowedLeafTypes: [
              LeafType.INTEGER,
              LeafType.DECIMAL
            ]
          }
        },
        featureColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          }
        },
        excludedColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          }
        }
      }
    }
  ],
  [PipelineStepType.EXPORT_DATA_CATALOG_DATASET]: [
    {
      stepType: PipelineStepType.EXPORT_DATA_CATALOG_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        datasetName: {
          kind: 'string',
          required: false
        },
        folderId: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.EXPORT_DATA_CATALOG_FILE]: [
    {
      stepType: PipelineStepType.EXPORT_DATA_CATALOG_FILE,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        fileName: {
          kind: 'string',
          required: true
        },
        folderId: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.EXTRACT_OR_REMOVE_LINES]: [
    {
      stepType: PipelineStepType.EXTRACT_OR_REMOVE_LINES,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        actionType: {
          kind: 'enum',
          required: true,
          choices: [
            'EXTRACT_LINES',
            'REMOVE_LINES'
          ]
        },
        startLine: {
          kind: 'integer',
          required: true
        },
        endLine: {
          kind: 'integer',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.FILTER_DATASET]: [
    {
      stepType: PipelineStepType.FILTER_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        filter: {
          kind: 'taggedUnion',
          required: true,
          tagKey: 'operation',
          choices: [
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'AND'
                },
                filters: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'taggedUnion',
                    required: true,
                    tagKey: 'operation',
                    choices: [
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'AND'
                          },
                          filters: {
                            kind: 'array',
                            required: true,
                            elementSpec: {
                              kind: 'taggedUnion',
                              required: true,
                              tagKey: 'operation',
                              choices: [
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'CONTAINS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'ENDS_WITH'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'EQUALS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'GREATER_THAN'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'GREATER_THAN_OR_EQUALS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'INCLUDES'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'IS_IN'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'IS_NULL'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'LESS_THAN'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'LESS_THAN_OR_EQUALS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'STARTS_WITH'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                }
                              ]
                            }
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'OR'
                          },
                          filters: {
                            kind: 'array',
                            required: true,
                            elementSpec: {
                              kind: 'taggedUnion',
                              required: true,
                              tagKey: 'operation',
                              choices: [
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'CONTAINS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'ENDS_WITH'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'EQUALS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'GREATER_THAN'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'GREATER_THAN_OR_EQUALS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'INCLUDES'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'IS_IN'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'IS_NULL'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'LESS_THAN'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'LESS_THAN_OR_EQUALS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'STARTS_WITH'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                }
                              ]
                            }
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'CONTAINS'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'ENDS_WITH'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'EQUALS'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'GREATER_THAN'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'GREATER_THAN_OR_EQUALS'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'INCLUDES'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'IS_IN'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'IS_NULL'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'LESS_THAN'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'LESS_THAN_OR_EQUALS'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'STARTS_WITH'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      }
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'OR'
                },
                filters: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'taggedUnion',
                    required: true,
                    tagKey: 'operation',
                    choices: [
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'AND'
                          },
                          filters: {
                            kind: 'array',
                            required: true,
                            elementSpec: {
                              kind: 'taggedUnion',
                              required: true,
                              tagKey: 'operation',
                              choices: [
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'CONTAINS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'ENDS_WITH'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'EQUALS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'GREATER_THAN'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'GREATER_THAN_OR_EQUALS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'INCLUDES'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'IS_IN'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'IS_NULL'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'LESS_THAN'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'LESS_THAN_OR_EQUALS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'STARTS_WITH'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                }
                              ]
                            }
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'OR'
                          },
                          filters: {
                            kind: 'array',
                            required: true,
                            elementSpec: {
                              kind: 'taggedUnion',
                              required: true,
                              tagKey: 'operation',
                              choices: [
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'CONTAINS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'ENDS_WITH'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'EQUALS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'GREATER_THAN'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'GREATER_THAN_OR_EQUALS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'INCLUDES'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'IS_IN'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'IS_NULL'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'LESS_THAN'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'LESS_THAN_OR_EQUALS'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    operation: {
                                      kind: 'string',
                                      required: true,
                                      value: 'STARTS_WITH'
                                    },
                                    columnSystemName: {
                                      kind: 'columnReference',
                                      required: true,
                                      inputDataName: 'Input dataset',
                                      validationOptions: null
                                    },
                                    not_: {
                                      kind: 'boolean',
                                      required: false
                                    },
                                    value: {
                                      kind: 'anything',
                                      required: true
                                    }
                                  }
                                }
                              ]
                            }
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'CONTAINS'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'ENDS_WITH'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'EQUALS'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'GREATER_THAN'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'GREATER_THAN_OR_EQUALS'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'INCLUDES'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'IS_IN'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'IS_NULL'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'LESS_THAN'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'LESS_THAN_OR_EQUALS'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      },
                      {
                        kind: 'shape',
                        required: true,
                        fields: {
                          operation: {
                            kind: 'string',
                            required: true,
                            value: 'STARTS_WITH'
                          },
                          columnSystemName: {
                            kind: 'columnReference',
                            required: true,
                            inputDataName: 'Input dataset',
                            validationOptions: null
                          },
                          not_: {
                            kind: 'boolean',
                            required: false
                          },
                          value: {
                            kind: 'anything',
                            required: true
                          }
                        }
                      }
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'CONTAINS'
                },
                columnSystemName: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                not_: {
                  kind: 'boolean',
                  required: false
                },
                value: {
                  kind: 'anything',
                  required: true
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'ENDS_WITH'
                },
                columnSystemName: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                not_: {
                  kind: 'boolean',
                  required: false
                },
                value: {
                  kind: 'anything',
                  required: true
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'EQUALS'
                },
                columnSystemName: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                not_: {
                  kind: 'boolean',
                  required: false
                },
                value: {
                  kind: 'anything',
                  required: true
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'GREATER_THAN'
                },
                columnSystemName: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                not_: {
                  kind: 'boolean',
                  required: false
                },
                value: {
                  kind: 'anything',
                  required: true
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'GREATER_THAN_OR_EQUALS'
                },
                columnSystemName: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                not_: {
                  kind: 'boolean',
                  required: false
                },
                value: {
                  kind: 'anything',
                  required: true
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'INCLUDES'
                },
                columnSystemName: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                not_: {
                  kind: 'boolean',
                  required: false
                },
                value: {
                  kind: 'anything',
                  required: true
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'IS_IN'
                },
                columnSystemName: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                not_: {
                  kind: 'boolean',
                  required: false
                },
                value: {
                  kind: 'anything',
                  required: true
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'IS_NULL'
                },
                columnSystemName: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                not_: {
                  kind: 'boolean',
                  required: false
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'LESS_THAN'
                },
                columnSystemName: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                not_: {
                  kind: 'boolean',
                  required: false
                },
                value: {
                  kind: 'anything',
                  required: true
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'LESS_THAN_OR_EQUALS'
                },
                columnSystemName: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                not_: {
                  kind: 'boolean',
                  required: false
                },
                value: {
                  kind: 'anything',
                  required: true
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                operation: {
                  kind: 'string',
                  required: true,
                  value: 'STARTS_WITH'
                },
                columnSystemName: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                not_: {
                  kind: 'boolean',
                  required: false
                },
                value: {
                  kind: 'anything',
                  required: true
                }
              }
            }
          ]
        }
      }
    }
  ],
  [PipelineStepType.FIND_AND_REPLACE]: [
    {
      stepType: PipelineStepType.FIND_AND_REPLACE,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        selectedColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ],
              listType: ColumnTypeValidationFlag.NOT_ALLOWED,
              nullableType: ColumnTypeValidationFlag.ALLOWED,
              maybeTextType: ColumnTypeValidationFlag.NOT_ALLOWED,
              strictLeafType: true
            }
          }
        },
        findAndReplaceOptions: {
          kind: 'taggedUnion',
          required: true,
          tagKey: 'findAndReplaceType',
          choices: [
            {
              kind: 'shape',
              required: true,
              fields: {
                replacementString: {
                  kind: 'string',
                  required: true
                },
                matchAllOccurrences: {
                  kind: 'boolean',
                  required: true
                },
                findAndReplaceType: {
                  kind: 'string',
                  required: true,
                  value: 'LITERAL'
                },
                literalString: {
                  kind: 'string',
                  required: true
                },
                matchWholeWord: {
                  kind: 'boolean',
                  required: true
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                replacementString: {
                  kind: 'string',
                  required: true
                },
                matchAllOccurrences: {
                  kind: 'boolean',
                  required: true
                },
                findAndReplaceType: {
                  kind: 'string',
                  required: true,
                  value: 'REGEX'
                },
                patternString: {
                  kind: 'string',
                  required: true
                }
              }
            }
          ]
        }
      }
    }
  ],
  [PipelineStepType.FLAG_ROWS]: [
    {
      stepType: PipelineStepType.FLAG_ROWS,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        flaggingInfoList: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              isFlagged: {
                kind: 'boolean',
                required: true
              },
              comment: {
                kind: 'string',
                required: true
              },
              rowIndices: {
                kind: 'array',
                required: true,
                elementSpec: {
                  kind: 'integer',
                  required: true
                }
              }
            }
          }
        }
      }
    }
  ],
  [PipelineStepType.GENERATE_FASTA]: [
    {
      stepType: PipelineStepType.GENERATE_FASTA,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {},
      outputDataShapes: {
        'FASTA File': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        structurePredictionRunId: {
          kind: 'integer',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.HIDE_COLUMNS]: [
    {
      stepType: PipelineStepType.HIDE_COLUMNS,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        columns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          }
        },
        columnsToKeep: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          }
        }
      }
    }
  ],
  [PipelineStepType.INITIALIZE_DATASET]: [
    {
      stepType: PipelineStepType.INITIALIZE_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {},
      outputDataShapes: {
        Dataset: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: null
    },
    {
      stepType: PipelineStepType.INITIALIZE_DATASET,
      isDeprecated: false,
      version: 1,
      inputDataShapes: {},
      outputDataShapes: {
        Dataset: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        dashboardId: {
          kind: 'string',
          required: true
        },
        blockId: {
          kind: 'string',
          required: true
        },
        dataFrameName: {
          kind: 'string',
          required: true
        },
        parameterizedSQLQuery: {
          kind: 'string',
          required: true
        },
        parameters: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              config: {
                kind: 'shape',
                required: true,
                fields: {
                  isMulti: {
                    kind: 'boolean',
                    required: false
                  },
                  systemName: {
                    kind: 'string',
                    required: true
                  },
                  type: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'BIOENTITY_LINK',
                      'DATE',
                      'ENTRY_LINK',
                      'FOLDER_LINK',
                      'NUMBER',
                      'PROCESS_LINK',
                      'PROCESS_TASK_LINK',
                      'PROJECT_LINK',
                      'SELECTOR',
                      'STORABLE_LINK',
                      'STRING',
                      'STUDY_LINK',
                      'TEAM_LINK',
                      'USER_LINK'
                    ]
                  },
                  id: {
                    kind: 'string',
                    required: true
                  }
                }
              },
              valueJson: {
                kind: 'anything',
                required: true
              }
            }
          }
        }
      }
    },
    {
      stepType: PipelineStepType.INITIALIZE_DATASET,
      isDeprecated: false,
      version: 2,
      inputDataShapes: {},
      outputDataShapes: {
        Dataset: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        dashboardId: {
          kind: 'string',
          required: true
        },
        blockId: {
          kind: 'string',
          required: true
        },
        dataFrameName: {
          kind: 'string',
          required: true
        },
        parameterizedSQLQuery: {
          kind: 'string',
          required: true
        },
        parameters: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              config: {
                kind: 'shape',
                required: true,
                fields: {
                  isMulti: {
                    kind: 'boolean',
                    required: false
                  },
                  systemName: {
                    kind: 'string',
                    required: true
                  },
                  type: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'BIOENTITY_LINK',
                      'DATE',
                      'ENTRY_LINK',
                      'FOLDER_LINK',
                      'NUMBER',
                      'PROCESS_LINK',
                      'PROCESS_TASK_LINK',
                      'PROJECT_LINK',
                      'SELECTOR',
                      'STORABLE_LINK',
                      'STRING',
                      'STUDY_LINK',
                      'TEAM_LINK',
                      'USER_LINK'
                    ]
                  },
                  id: {
                    kind: 'string',
                    required: true
                  }
                }
              },
              valueJson: {
                kind: 'anything',
                required: true
              }
            }
          }
        },
        dashboardName: {
          kind: 'string',
          required: true
        },
        blockName: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.INTERPOLATE_MARKDOWN]: [
    {
      stepType: PipelineStepType.INTERPOLATE_MARKDOWN,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input datasets': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        markdownTemplate: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.JOIN]: [
    {
      stepType: PipelineStepType.JOIN,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        Left: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        Right: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        dataFrameName: {
          kind: 'string',
          required: true
        },
        joinType: {
          kind: 'enum',
          required: true,
          choices: [
            'INNER',
            'LEFT_OUTER',
            'RIGHT_OUTER',
            'FULL_OUTER',
            'NATURAL',
            'POSITIONAL'
          ]
        },
        joinConditions: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              leftDataSourceColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Left',
                validationOptions: null
              },
              rightDataSourceColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Right',
                validationOptions: null
              }
            }
          }
        }
      }
    }
  ],
  [PipelineStepType.LAYOUT]: [
    {
      stepType: PipelineStepType.LAYOUT,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Config datasets': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        },
        'Config charts': {
          kind: PipelineStepDataKind.CHART,
          isMulti: true,
          isRequired: false
        },
        'Config files': {
          kind: PipelineStepDataKind.FILE,
          isMulti: true,
          isRequired: false
        },
        'Input datasets': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        },
        'Input files': {
          kind: PipelineStepDataKind.FILE,
          isMulti: true,
          isRequired: false
        },
        'Input charts': {
          kind: PipelineStepDataKind.CHART,
          isMulti: true,
          isRequired: false
        }
      },
      outputDataShapes: {},
      config: {
        sections: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'taggedUnion',
            required: true,
            tagKey: 'type',
            choices: [
              {
                kind: 'shape',
                required: true,
                fields: {
                  type: {
                    kind: 'string',
                    required: true,
                    value: 'GRID'
                  },
                  title: {
                    kind: 'string',
                    required: false
                  },
                  grid: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      rows: {
                        kind: 'array',
                        required: true,
                        elementSpec: {
                          kind: 'array',
                          required: true,
                          elementSpec: {
                            kind: 'taggedUnion',
                            required: true,
                            tagKey: 'type',
                            choices: [
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  type: {
                                    kind: 'string',
                                    required: true,
                                    value: 'DATA_VIEW'
                                  },
                                  inputReference: {
                                    kind: 'shape',
                                    required: true,
                                    fields: {
                                      inputDataName: {
                                        kind: 'enum',
                                        required: true,
                                        choices: [
                                          'Input datasets',
                                          'Input charts',
                                          'Input files'
                                        ]
                                      },
                                      inputDataIndex: {
                                        kind: 'integer',
                                        required: true
                                      }
                                    }
                                  },
                                  blockConfig: {
                                    kind: 'shape',
                                    required: false,
                                    fields: {
                                      title: {
                                        kind: 'string',
                                        required: false
                                      },
                                      subtitle: {
                                        kind: 'string',
                                        required: false
                                      },
                                      infoText: {
                                        kind: 'string',
                                        required: false
                                      },
                                      collapsingBodyTitle: {
                                        kind: 'string',
                                        required: false
                                      }
                                    }
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  type: {
                                    kind: 'string',
                                    required: true,
                                    value: 'CONFIG_FORM'
                                  },
                                  blockConfig: {
                                    kind: 'shape',
                                    required: false,
                                    fields: {
                                      title: {
                                        kind: 'string',
                                        required: false
                                      },
                                      subtitle: {
                                        kind: 'string',
                                        required: false
                                      },
                                      infoText: {
                                        kind: 'string',
                                        required: false
                                      },
                                      collapsingBodyTitle: {
                                        kind: 'string',
                                        required: false
                                      }
                                    }
                                  },
                                  configFields: {
                                    kind: 'array',
                                    required: true,
                                    elementSpec: {
                                      kind: 'shape',
                                      required: true,
                                      fields: {
                                        configReferences: {
                                          kind: 'array',
                                          required: true,
                                          elementSpec: {
                                            kind: 'shape',
                                            required: true,
                                            fields: {
                                              configDataName: {
                                                kind: 'enum',
                                                required: true,
                                                choices: [
                                                  'Config datasets',
                                                  'Config charts',
                                                  'Config files'
                                                ]
                                              },
                                              configDataIndex: {
                                                kind: 'integer',
                                                required: true
                                              },
                                              configPath: {
                                                kind: 'array',
                                                required: true,
                                                elementSpec: {
                                                  kind: 'anything',
                                                  required: true
                                                }
                                              }
                                            }
                                          }
                                        },
                                        configSpec: {
                                          kind: 'taggedUnion',
                                          required: true,
                                          tagKey: 'kind',
                                          choices: [
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'boolean'
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'columnReference'
                                                },
                                                inputDataName: {
                                                  kind: 'string',
                                                  required: true
                                                },
                                                validationOptions: {
                                                  kind: 'shape',
                                                  required: false,
                                                  fields: {
                                                    allowedLeafTypes: {
                                                      kind: 'array',
                                                      required: false,
                                                      elementSpec: {
                                                        kind: 'enum',
                                                        required: true,
                                                        choices: [
                                                          'BOOLEAN',
                                                          'DATETIME',
                                                          'DATE',
                                                          'DECIMAL',
                                                          'INTEGER',
                                                          'JSON',
                                                          'TEXT',
                                                          'BENCHLING_OBJECT',
                                                          'BLOB',
                                                          'DROPDOWN_OPTION',
                                                          'BATCH',
                                                          'BIOENTITY',
                                                          'BASIC_FOLDER_ITEM',
                                                          'MIXTURE',
                                                          'MOLECULE',
                                                          'PROTEIN',
                                                          'SEQUENCE',
                                                          'ENTRY',
                                                          'PROTOCOL',
                                                          'REQUEST',
                                                          'RESULT',
                                                          'RUN',
                                                          'STORABLE',
                                                          'BOX',
                                                          'CONTAINER',
                                                          'LOCATION',
                                                          'PLATE',
                                                          'PROCESS',
                                                          'PROCESS_TASK',
                                                          'PROCESS_OUTPUT',
                                                          'STUDY',
                                                          'TEAM',
                                                          'TEST_ORDER',
                                                          'USER'
                                                        ]
                                                      }
                                                    },
                                                    listType: {
                                                      kind: 'enum',
                                                      required: false,
                                                      choices: [
                                                        'ALLOWED',
                                                        'REQUIRED',
                                                        'NOT_ALLOWED'
                                                      ]
                                                    },
                                                    nullableType: {
                                                      kind: 'enum',
                                                      required: false,
                                                      choices: [
                                                        'ALLOWED',
                                                        'REQUIRED',
                                                        'NOT_ALLOWED'
                                                      ]
                                                    },
                                                    maybeTextType: {
                                                      kind: 'enum',
                                                      required: false,
                                                      choices: [
                                                        'ALLOWED',
                                                        'REQUIRED',
                                                        'NOT_ALLOWED'
                                                      ]
                                                    },
                                                    strictLeafType: {
                                                      kind: 'boolean',
                                                      required: false
                                                    }
                                                  }
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'columnValue'
                                                },
                                                columnSystemName: {
                                                  kind: 'string',
                                                  required: true
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'enum'
                                                },
                                                choices: {
                                                  kind: 'array',
                                                  required: true,
                                                  elementSpec: {
                                                    kind: 'string',
                                                    required: true
                                                  }
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'integer'
                                                },
                                                minValue: {
                                                  kind: 'integer',
                                                  required: false
                                                },
                                                maxValue: {
                                                  kind: 'integer',
                                                  required: false
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'number'
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'string'
                                                },
                                                value: {
                                                  kind: 'string',
                                                  required: false
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'tableReference'
                                                },
                                                inputDataName: {
                                                  kind: 'string',
                                                  required: true
                                                },
                                                inputDataIndex: {
                                                  kind: 'integer',
                                                  required: true
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            }
                                          ]
                                        },
                                        uiSchema: {
                                          kind: 'shape',
                                          required: true,
                                          fields: {
                                            displayName: {
                                              kind: 'string',
                                              required: false
                                            },
                                            editorOverride: {
                                              kind: 'enum',
                                              required: false,
                                              choices: [
                                                'CHECKBOX'
                                              ]
                                            },
                                            infoText: {
                                              kind: 'string',
                                              required: false
                                            },
                                            fieldSettings: {
                                              kind: 'taggedUnion',
                                              required: false,
                                              tagKey: 'type',
                                              choices: [
                                                {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    type: {
                                                      kind: 'string',
                                                      required: true,
                                                      value: 'CHECKBOX_SETTINGS'
                                                    },
                                                    checkboxLabel: {
                                                      kind: 'string',
                                                      required: true
                                                    }
                                                  }
                                                },
                                                {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    type: {
                                                      kind: 'string',
                                                      required: true,
                                                      value: 'COLUMN_REFERENCE_SETTINGS'
                                                    },
                                                    noColumnSelectedText: {
                                                      kind: 'string',
                                                      required: false
                                                    },
                                                    allowSelectNull: {
                                                      kind: 'boolean',
                                                      required: false
                                                    },
                                                    systemNameWildcardSelector: {
                                                      kind: 'string',
                                                      required: false
                                                    }
                                                  }
                                                },
                                                {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    type: {
                                                      kind: 'string',
                                                      required: true,
                                                      value: 'COLUMN_VALUE_SETTINGS'
                                                    },
                                                    noValueSelectedText: {
                                                      kind: 'string',
                                                      required: false
                                                    }
                                                  }
                                                },
                                                {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    type: {
                                                      kind: 'string',
                                                      required: true,
                                                      value: 'ENUM_SETTINGS'
                                                    },
                                                    displayNames: {
                                                      kind: 'array',
                                                      required: false,
                                                      elementSpec: {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          value: {
                                                            kind: 'string',
                                                            required: true
                                                          },
                                                          displayName: {
                                                            kind: 'string',
                                                            required: true
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                },
                                                {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    type: {
                                                      kind: 'string',
                                                      required: true,
                                                      value: 'TABLE_REFERENCE_SETTINGS'
                                                    },
                                                    disabledColumn: {
                                                      kind: 'array',
                                                      required: false,
                                                      elementSpec: {
                                                        kind: 'string',
                                                        required: true
                                                      }
                                                    },
                                                    hiddenColumn: {
                                                      kind: 'array',
                                                      required: false,
                                                      elementSpec: {
                                                        kind: 'string',
                                                        required: true
                                                      }
                                                    }
                                                  }
                                                },
                                                {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    type: {
                                                      kind: 'string',
                                                      required: true,
                                                      value: 'TAGGED_UNION_SETTINGS'
                                                    },
                                                    tagKeyDisplayNames: {
                                                      kind: 'array',
                                                      required: false,
                                                      elementSpec: {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          value: {
                                                            kind: 'string',
                                                            required: true
                                                          },
                                                          displayName: {
                                                            kind: 'string',
                                                            required: true
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        }
                                      }
                                    }
                                  },
                                  submitOptions: {
                                    kind: 'shape',
                                    required: false,
                                    fields: {
                                      submitButtonText: {
                                        kind: 'string',
                                        required: true
                                      },
                                      submitButtonIcon: {
                                        kind: 'string',
                                        required: true
                                      }
                                    }
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  type: {
                                    kind: 'string',
                                    required: true,
                                    value: 'MARKDOWN'
                                  },
                                  markdown: {
                                    kind: 'string',
                                    required: true
                                  },
                                  blockConfig: {
                                    kind: 'shape',
                                    required: false,
                                    fields: {
                                      title: {
                                        kind: 'string',
                                        required: false
                                      },
                                      subtitle: {
                                        kind: 'string',
                                        required: false
                                      },
                                      infoText: {
                                        kind: 'string',
                                        required: false
                                      },
                                      collapsingBodyTitle: {
                                        kind: 'string',
                                        required: false
                                      }
                                    }
                                  }
                                }
                              }
                            ]
                          }
                        }
                      }
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  type: {
                    kind: 'string',
                    required: true,
                    value: 'TAB'
                  },
                  title: {
                    kind: 'string',
                    required: false
                  },
                  tabs: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        title: {
                          kind: 'string',
                          required: true
                        },
                        grid: {
                          kind: 'shape',
                          required: true,
                          fields: {
                            rows: {
                              kind: 'array',
                              required: true,
                              elementSpec: {
                                kind: 'array',
                                required: true,
                                elementSpec: {
                                  kind: 'taggedUnion',
                                  required: true,
                                  tagKey: 'type',
                                  choices: [
                                    {
                                      kind: 'shape',
                                      required: true,
                                      fields: {
                                        type: {
                                          kind: 'string',
                                          required: true,
                                          value: 'DATA_VIEW'
                                        },
                                        inputReference: {
                                          kind: 'shape',
                                          required: true,
                                          fields: {
                                            inputDataName: {
                                              kind: 'enum',
                                              required: true,
                                              choices: [
                                                'Input datasets',
                                                'Input charts',
                                                'Input files'
                                              ]
                                            },
                                            inputDataIndex: {
                                              kind: 'integer',
                                              required: true
                                            }
                                          }
                                        },
                                        blockConfig: {
                                          kind: 'shape',
                                          required: false,
                                          fields: {
                                            title: {
                                              kind: 'string',
                                              required: false
                                            },
                                            subtitle: {
                                              kind: 'string',
                                              required: false
                                            },
                                            infoText: {
                                              kind: 'string',
                                              required: false
                                            },
                                            collapsingBodyTitle: {
                                              kind: 'string',
                                              required: false
                                            }
                                          }
                                        }
                                      }
                                    },
                                    {
                                      kind: 'shape',
                                      required: true,
                                      fields: {
                                        type: {
                                          kind: 'string',
                                          required: true,
                                          value: 'CONFIG_FORM'
                                        },
                                        blockConfig: {
                                          kind: 'shape',
                                          required: false,
                                          fields: {
                                            title: {
                                              kind: 'string',
                                              required: false
                                            },
                                            subtitle: {
                                              kind: 'string',
                                              required: false
                                            },
                                            infoText: {
                                              kind: 'string',
                                              required: false
                                            },
                                            collapsingBodyTitle: {
                                              kind: 'string',
                                              required: false
                                            }
                                          }
                                        },
                                        configFields: {
                                          kind: 'array',
                                          required: true,
                                          elementSpec: {
                                            kind: 'shape',
                                            required: true,
                                            fields: {
                                              configReferences: {
                                                kind: 'array',
                                                required: true,
                                                elementSpec: {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    configDataName: {
                                                      kind: 'enum',
                                                      required: true,
                                                      choices: [
                                                        'Config datasets',
                                                        'Config charts',
                                                        'Config files'
                                                      ]
                                                    },
                                                    configDataIndex: {
                                                      kind: 'integer',
                                                      required: true
                                                    },
                                                    configPath: {
                                                      kind: 'array',
                                                      required: true,
                                                      elementSpec: {
                                                        kind: 'anything',
                                                        required: true
                                                      }
                                                    }
                                                  }
                                                }
                                              },
                                              configSpec: {
                                                kind: 'taggedUnion',
                                                required: true,
                                                tagKey: 'kind',
                                                choices: [
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'boolean'
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'columnReference'
                                                      },
                                                      inputDataName: {
                                                        kind: 'string',
                                                        required: true
                                                      },
                                                      validationOptions: {
                                                        kind: 'shape',
                                                        required: false,
                                                        fields: {
                                                          allowedLeafTypes: {
                                                            kind: 'array',
                                                            required: false,
                                                            elementSpec: {
                                                              kind: 'enum',
                                                              required: true,
                                                              choices: [
                                                                'BOOLEAN',
                                                                'DATETIME',
                                                                'DATE',
                                                                'DECIMAL',
                                                                'INTEGER',
                                                                'JSON',
                                                                'TEXT',
                                                                'BENCHLING_OBJECT',
                                                                'BLOB',
                                                                'DROPDOWN_OPTION',
                                                                'BATCH',
                                                                'BIOENTITY',
                                                                'BASIC_FOLDER_ITEM',
                                                                'MIXTURE',
                                                                'MOLECULE',
                                                                'PROTEIN',
                                                                'SEQUENCE',
                                                                'ENTRY',
                                                                'PROTOCOL',
                                                                'REQUEST',
                                                                'RESULT',
                                                                'RUN',
                                                                'STORABLE',
                                                                'BOX',
                                                                'CONTAINER',
                                                                'LOCATION',
                                                                'PLATE',
                                                                'PROCESS',
                                                                'PROCESS_TASK',
                                                                'PROCESS_OUTPUT',
                                                                'STUDY',
                                                                'TEAM',
                                                                'TEST_ORDER',
                                                                'USER'
                                                              ]
                                                            }
                                                          },
                                                          listType: {
                                                            kind: 'enum',
                                                            required: false,
                                                            choices: [
                                                              'ALLOWED',
                                                              'REQUIRED',
                                                              'NOT_ALLOWED'
                                                            ]
                                                          },
                                                          nullableType: {
                                                            kind: 'enum',
                                                            required: false,
                                                            choices: [
                                                              'ALLOWED',
                                                              'REQUIRED',
                                                              'NOT_ALLOWED'
                                                            ]
                                                          },
                                                          maybeTextType: {
                                                            kind: 'enum',
                                                            required: false,
                                                            choices: [
                                                              'ALLOWED',
                                                              'REQUIRED',
                                                              'NOT_ALLOWED'
                                                            ]
                                                          },
                                                          strictLeafType: {
                                                            kind: 'boolean',
                                                            required: false
                                                          }
                                                        }
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'columnValue'
                                                      },
                                                      columnSystemName: {
                                                        kind: 'string',
                                                        required: true
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'enum'
                                                      },
                                                      choices: {
                                                        kind: 'array',
                                                        required: true,
                                                        elementSpec: {
                                                          kind: 'string',
                                                          required: true
                                                        }
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'integer'
                                                      },
                                                      minValue: {
                                                        kind: 'integer',
                                                        required: false
                                                      },
                                                      maxValue: {
                                                        kind: 'integer',
                                                        required: false
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'number'
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'string'
                                                      },
                                                      value: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'tableReference'
                                                      },
                                                      inputDataName: {
                                                        kind: 'string',
                                                        required: true
                                                      },
                                                      inputDataIndex: {
                                                        kind: 'integer',
                                                        required: true
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  }
                                                ]
                                              },
                                              uiSchema: {
                                                kind: 'shape',
                                                required: true,
                                                fields: {
                                                  displayName: {
                                                    kind: 'string',
                                                    required: false
                                                  },
                                                  editorOverride: {
                                                    kind: 'enum',
                                                    required: false,
                                                    choices: [
                                                      'CHECKBOX'
                                                    ]
                                                  },
                                                  infoText: {
                                                    kind: 'string',
                                                    required: false
                                                  },
                                                  fieldSettings: {
                                                    kind: 'taggedUnion',
                                                    required: false,
                                                    tagKey: 'type',
                                                    choices: [
                                                      {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          type: {
                                                            kind: 'string',
                                                            required: true,
                                                            value: 'CHECKBOX_SETTINGS'
                                                          },
                                                          checkboxLabel: {
                                                            kind: 'string',
                                                            required: true
                                                          }
                                                        }
                                                      },
                                                      {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          type: {
                                                            kind: 'string',
                                                            required: true,
                                                            value: 'COLUMN_REFERENCE_SETTINGS'
                                                          },
                                                          noColumnSelectedText: {
                                                            kind: 'string',
                                                            required: false
                                                          },
                                                          allowSelectNull: {
                                                            kind: 'boolean',
                                                            required: false
                                                          },
                                                          systemNameWildcardSelector: {
                                                            kind: 'string',
                                                            required: false
                                                          }
                                                        }
                                                      },
                                                      {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          type: {
                                                            kind: 'string',
                                                            required: true,
                                                            value: 'COLUMN_VALUE_SETTINGS'
                                                          },
                                                          noValueSelectedText: {
                                                            kind: 'string',
                                                            required: false
                                                          }
                                                        }
                                                      },
                                                      {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          type: {
                                                            kind: 'string',
                                                            required: true,
                                                            value: 'ENUM_SETTINGS'
                                                          },
                                                          displayNames: {
                                                            kind: 'array',
                                                            required: false,
                                                            elementSpec: {
                                                              kind: 'shape',
                                                              required: true,
                                                              fields: {
                                                                value: {
                                                                  kind: 'string',
                                                                  required: true
                                                                },
                                                                displayName: {
                                                                  kind: 'string',
                                                                  required: true
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      },
                                                      {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          type: {
                                                            kind: 'string',
                                                            required: true,
                                                            value: 'TABLE_REFERENCE_SETTINGS'
                                                          },
                                                          disabledColumn: {
                                                            kind: 'array',
                                                            required: false,
                                                            elementSpec: {
                                                              kind: 'string',
                                                              required: true
                                                            }
                                                          },
                                                          hiddenColumn: {
                                                            kind: 'array',
                                                            required: false,
                                                            elementSpec: {
                                                              kind: 'string',
                                                              required: true
                                                            }
                                                          }
                                                        }
                                                      },
                                                      {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          type: {
                                                            kind: 'string',
                                                            required: true,
                                                            value: 'TAGGED_UNION_SETTINGS'
                                                          },
                                                          tagKeyDisplayNames: {
                                                            kind: 'array',
                                                            required: false,
                                                            elementSpec: {
                                                              kind: 'shape',
                                                              required: true,
                                                              fields: {
                                                                value: {
                                                                  kind: 'string',
                                                                  required: true
                                                                },
                                                                displayName: {
                                                                  kind: 'string',
                                                                  required: true
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    ]
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        },
                                        submitOptions: {
                                          kind: 'shape',
                                          required: false,
                                          fields: {
                                            submitButtonText: {
                                              kind: 'string',
                                              required: true
                                            },
                                            submitButtonIcon: {
                                              kind: 'string',
                                              required: true
                                            }
                                          }
                                        }
                                      }
                                    },
                                    {
                                      kind: 'shape',
                                      required: true,
                                      fields: {
                                        type: {
                                          kind: 'string',
                                          required: true,
                                          value: 'MARKDOWN'
                                        },
                                        markdown: {
                                          kind: 'string',
                                          required: true
                                        },
                                        blockConfig: {
                                          kind: 'shape',
                                          required: false,
                                          fields: {
                                            title: {
                                              kind: 'string',
                                              required: false
                                            },
                                            subtitle: {
                                              kind: 'string',
                                              required: false
                                            },
                                            infoText: {
                                              kind: 'string',
                                              required: false
                                            },
                                            collapsingBodyTitle: {
                                              kind: 'string',
                                              required: false
                                            }
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }
  ],
  [PipelineStepType.LOOK_UP]: [
    {
      stepType: PipelineStepType.LOOK_UP,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        dataFrameName: {
          kind: 'string',
          required: true
        },
        lookupBy: {
          kind: 'enum',
          required: true,
          choices: [
            'id',
            'name',
            'barcode'
          ]
        },
        lookupColumn: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          validationOptions: null
        },
        query: {
          kind: 'string',
          required: true
        },
        schemaId: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.MAP_COLUMNS]: [
    {
      stepType: PipelineStepType.MAP_COLUMNS,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input datasets': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output datasets': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: true
        }
      },
      config: {
        mapColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'array',
            required: true,
            elementSpec: {
              kind: 'shape',
              required: true,
              fields: {
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input datasets',
                  validationOptions: null
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                }
              }
            }
          }
        }
      }
    }
  ],
  [PipelineStepType.MAP_JSON_TO_DATASETS_AND_FILES]: [
    {
      stepType: PipelineStepType.MAP_JSON_TO_DATASETS_AND_FILES,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output files': {
          kind: PipelineStepDataKind.FILE,
          isMulti: true,
          isRequired: false
        },
        'Output datasets': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        }
      },
      config: {
        datasets: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              name: {
                kind: 'string',
                required: true
              },
              columns: {
                kind: 'array',
                required: true,
                elementSpec: {
                  kind: 'shape',
                  required: true,
                  fields: {
                    name: {
                      kind: 'string',
                      required: true
                    },
                    path: {
                      kind: 'string',
                      required: true
                    },
                    include: {
                      kind: 'boolean',
                      required: true
                    },
                    required: {
                      kind: 'boolean',
                      required: true
                    }
                  }
                },
                minItems: 1
              },
              include: {
                kind: 'boolean',
                required: true
              },
              is_metadata: {
                kind: 'boolean',
                required: true
              }
            }
          },
          minItems: 1
        },
        transforms: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'taggedUnion',
            required: true,
            tagKey: 'type',
            choices: [
              {
                kind: 'shape',
                required: true,
                fields: {
                  type: {
                    kind: 'string',
                    required: true,
                    value: 'JOIN'
                  },
                  dataset_1: {
                    kind: 'string',
                    required: true
                  },
                  dataset_2: {
                    kind: 'string',
                    required: true
                  },
                  join_key_1: {
                    kind: 'string',
                    required: true
                  },
                  join_key_2: {
                    kind: 'string',
                    required: true
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  type: {
                    kind: 'string',
                    required: true,
                    value: 'PIVOT'
                  },
                  dataset: {
                    kind: 'string',
                    required: true
                  },
                  path: {
                    kind: 'string',
                    required: true
                  },
                  value_path: {
                    kind: 'string',
                    required: true
                  },
                  label_path: {
                    kind: 'string',
                    required: true
                  }
                }
              }
            ]
          }
        }
      }
    }
  ],
  [PipelineStepType.NOTEBOOK_TABLE_DATASET]: [
    {
      stepType: PipelineStepType.NOTEBOOK_TABLE_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {},
      outputDataShapes: {
        Dataset: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        entryId: {
          kind: 'string',
          required: true
        },
        entryName: {
          kind: 'string',
          required: true
        },
        tableId: {
          kind: 'string',
          required: true
        },
        tableName: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.PARAMETER_OPTIMIZATION_CONFIGURATION]: [
    {
      stepType: PipelineStepType.PARAMETER_OPTIMIZATION_CONFIGURATION,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        labelColumn: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          validationOptions: {
            allowedLeafTypes: [
              LeafType.INTEGER,
              LeafType.DECIMAL
            ]
          }
        },
        featureColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          }
        },
        groupingColumn: {
          kind: 'columnReference',
          required: false,
          inputDataName: 'Input dataset',
          validationOptions: null
        },
        excludedColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          }
        },
        metadataColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          }
        }
      }
    }
  ],
  [PipelineStepType.PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION]: [
    {
      stepType: PipelineStepType.PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION,
      isDeprecated: true,
      version: 0,
      inputDataShapes: {},
      outputDataShapes: {
        'Model training input': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: true
        },
        'Feature data': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Feature descriptions': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Label data': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Label description': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        datasetConfiguration: {
          kind: 'anything',
          required: true
        },
        dataDefinitionConfig: {
          kind: 'anything',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.PARAMETER_OPTIMIZATION_MODELING]: [
    {
      stepType: PipelineStepType.PARAMETER_OPTIMIZATION_MODELING,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {},
      outputDataShapes: {
        'Model training input': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: true
        },
        'All data': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Feature importance': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'SHAP values': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Model evaluation': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Search rankings': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: false
        },
        'Feature data': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: false
        },
        'Feature descriptions': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: false
        },
        'Label data': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: false
        },
        'Label description': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: false
        },
        exclusion_reasons: {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: false
        }
      },
      config: {
        datasetConfiguration: {
          kind: 'anything',
          required: true
        },
        dataDefinitionConfig: {
          kind: 'anything',
          required: true
        }
      }
    },
    {
      stepType: PipelineStepType.PARAMETER_OPTIMIZATION_MODELING,
      isDeprecated: false,
      version: 1,
      inputDataShapes: {
        'Feature data': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Label data': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'All data': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Feature importance': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'SHAP values': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Model evaluation': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Search rankings': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: false
        },
        exclusion_reasons: {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: false
        }
      },
      config: null
    },
    {
      stepType: PipelineStepType.PARAMETER_OPTIMIZATION_MODELING,
      isDeprecated: false,
      version: 2,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'All data': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Feature importance': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'SHAP values': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Model evaluation': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Search rankings': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Predictions default values': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Predictions grid': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Extra data frames': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        },
        'Extra charts': {
          kind: PipelineStepDataKind.CHART,
          isMulti: true,
          isRequired: false
        }
      },
      config: null
    }
  ],
  [PipelineStepType.PARAMETER_OPTIMIZATION_PREDICTION]: [
    {
      stepType: PipelineStepType.PARAMETER_OPTIMIZATION_PREDICTION,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Model training input': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: true
        },
        'All data': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Feature importance': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Predictions default values': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: false
        },
        'Predictions grid': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: false
        }
      },
      config: null
    },
    {
      stepType: PipelineStepType.PARAMETER_OPTIMIZATION_PREDICTION,
      isDeprecated: false,
      version: 1,
      inputDataShapes: {
        'Model training input': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: true
        },
        'All data': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Feature importance': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Predictions default values': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: false
        },
        'Predictions grid': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: false
        },
        contour_plots_partial_dependence: {
          kind: PipelineStepDataKind.FILE,
          isMulti: true,
          isRequired: false
        }
      },
      config: null
    }
  ],
  [PipelineStepType.PIVOT_DATASET]: [
    {
      stepType: PipelineStepType.PIVOT_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        pivotColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          },
          minItems: 1
        },
        valueColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'taggedUnion',
            required: true,
            tagKey: 'aggregationFunction',
            choices: [
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'AVERAGE'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: false
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'COUNT'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: false
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'COUNT_NULLS'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: false
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'MAX'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: false
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'MEDIAN'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: false
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'MIN'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: false
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'MODE'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: false
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'PRODUCT'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: false
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'STANDARD_DEVIATION'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: false
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'STANDARD_ERROR'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: false
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'SUM'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: false
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'VARIANCE'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: false
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              }
            ]
          },
          minItems: 1
        },
        groupColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          }
        }
      }
    }
  ],
  [PipelineStepType.PLATE_SCHEMA_DATASET]: [
    {
      stepType: PipelineStepType.PLATE_SCHEMA_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {},
      outputDataShapes: {
        Dataset: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        dataFrameName: {
          kind: 'string',
          required: true
        },
        plateIds: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'string',
            required: true
          }
        },
        query: {
          kind: 'string',
          required: true
        },
        queryDescription: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.PROCEDURE_RUN_DATA_FRAMES]: [
    {
      stepType: PipelineStepType.PROCEDURE_RUN_DATA_FRAMES,
      isDeprecated: true,
      version: 0,
      inputDataShapes: {},
      outputDataShapes: {
        CONDITION_REPLICATE_CONFIRMATION: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        DATA_PARAMETER_ACTUAL: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        MATERIAL_PARAMETER_CONFIRMATION: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        RESULTS: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        },
        ENTITIES: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        }
      },
      config: {
        procedureRunConfigs: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              procedureRunId: {
                kind: 'string',
                required: true
              }
            }
          }
        }
      }
    }
  ],
  [PipelineStepType.PROMOTE_DATASET]: [
    {
      stepType: PipelineStepType.PROMOTE_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {}
    }
  ],
  [PipelineStepType.REGISTRY_SCHEMA_DATASET]: [
    {
      stepType: PipelineStepType.REGISTRY_SCHEMA_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {},
      outputDataShapes: {
        Dataset: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        dataFrameName: {
          kind: 'string',
          required: true
        },
        query: {
          kind: 'string',
          required: true
        },
        queryDescription: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.REGRESSION]: [
    {
      stepType: PipelineStepType.REGRESSION,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Model variables': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Model output': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Output chart': {
          kind: PipelineStepDataKind.CHART,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        name: {
          kind: 'string',
          required: true
        },
        regressionConfig: {
          kind: 'taggedUnion',
          required: true,
          tagKey: 'modelType',
          choices: [
            {
              kind: 'shape',
              required: true,
              fields: {
                modelType: {
                  kind: 'string',
                  required: true,
                  value: 'LINEAR'
                },
                xColumn: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                },
                yColumn: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                },
                weightColumn: {
                  kind: 'columnReference',
                  required: false,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                },
                partitionColumn: {
                  kind: 'columnReference',
                  required: false,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                modelType: {
                  kind: 'string',
                  required: true,
                  value: 'QUADRATIC'
                },
                xColumn: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                },
                yColumn: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                },
                weightColumn: {
                  kind: 'columnReference',
                  required: false,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                },
                partitionColumn: {
                  kind: 'columnReference',
                  required: false,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                modelType: {
                  kind: 'string',
                  required: true,
                  value: 'LOGISTIC'
                },
                xColumn: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                },
                yColumn: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                },
                weightColumn: {
                  kind: 'columnReference',
                  required: false,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                },
                partitionColumn: {
                  kind: 'columnReference',
                  required: false,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                parameterCustomizations: {
                  kind: 'array',
                  required: false,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      name: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'MIN',
                          'MAX',
                          'IC50',
                          'HILL_SLOPE'
                        ]
                      },
                      initialValue: {
                        kind: 'number',
                        required: false
                      },
                      constraint: {
                        kind: 'taggedUnion',
                        required: true,
                        tagKey: 'type',
                        choices: [
                          {
                            kind: 'shape',
                            required: true,
                            fields: {
                              type: {
                                kind: 'string',
                                required: true,
                                value: 'NONE'
                              }
                            }
                          },
                          {
                            kind: 'shape',
                            required: true,
                            fields: {
                              type: {
                                kind: 'string',
                                required: true,
                                value: 'EQUAL'
                              },
                              value: {
                                kind: 'number',
                                required: true
                              }
                            }
                          },
                          {
                            kind: 'shape',
                            required: true,
                            fields: {
                              type: {
                                kind: 'string',
                                required: true,
                                value: 'LESS_THAN'
                              },
                              upperBound: {
                                kind: 'number',
                                required: true
                              }
                            }
                          },
                          {
                            kind: 'shape',
                            required: true,
                            fields: {
                              type: {
                                kind: 'string',
                                required: true,
                                value: 'GREATER_THAN'
                              },
                              lowerBound: {
                                kind: 'number',
                                required: true
                              }
                            }
                          },
                          {
                            kind: 'shape',
                            required: true,
                            fields: {
                              type: {
                                kind: 'string',
                                required: true,
                                value: 'BETWEEN'
                              },
                              lowerBound: {
                                kind: 'number',
                                required: true
                              },
                              upperBound: {
                                kind: 'number',
                                required: true
                              }
                            }
                          }
                        ]
                      }
                    }
                  }
                }
              }
            }
          ]
        }
      }
    }
  ],
  [PipelineStepType.REGRESSION_INTERPOLATION]: [
    {
      stepType: PipelineStepType.REGRESSION_INTERPOLATION,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Model variables': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        selectedPartitionValue: {
          kind: 'anything',
          required: false
        },
        inputColumn: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          validationOptions: {
            allowedLeafTypes: [
              LeafType.INTEGER,
              LeafType.DECIMAL
            ]
          }
        },
        inputPartitionColumn: {
          kind: 'columnReference',
          required: false,
          inputDataName: 'Input dataset',
          validationOptions: null
        },
        isInputX: {
          kind: 'boolean',
          required: false
        }
      }
    }
  ],
  [PipelineStepType.RENAME_COLUMNS]: [
    {
      stepType: PipelineStepType.RENAME_COLUMNS,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        renameColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              column: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              name: {
                kind: 'string',
                required: true
              }
            }
          },
          minItems: 1
        }
      }
    }
  ],
  [PipelineStepType.REORDER_COLUMNS]: [
    {
      stepType: PipelineStepType.REORDER_COLUMNS,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        reorderColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          }
        }
      }
    }
  ],
  [PipelineStepType.RETYPE_COLUMNS]: [
    {
      stepType: PipelineStepType.RETYPE_COLUMNS,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        retypeColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              column: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              type: {
                kind: 'enum',
                required: true,
                choices: [
                  'STRING',
                  'INT',
                  'DOUBLE',
                  'BOOLEAN'
                ]
              }
            }
          },
          minItems: 1
        }
      }
    }
  ],
  [PipelineStepType.SAVE_STRUCTURE_PREDICTION]: [
    {
      stepType: PipelineStepType.SAVE_STRUCTURE_PREDICTION,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Predicted structure': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        },
        'Prediction metadata': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: false
        }
      },
      outputDataShapes: {},
      config: {
        structurePredictionRunId: {
          kind: 'integer',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.SAVE_TO_RESULTS]: [
    {
      stepType: PipelineStepType.SAVE_TO_RESULTS,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Saved results': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Rows with errors': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: null
    },
    {
      stepType: PipelineStepType.SAVE_TO_RESULTS,
      isDeprecated: false,
      version: 1,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Saved results': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Rows with errors': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        schemaId: {
          kind: 'string',
          required: true
        },
        columnMapping: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              inputColumnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              outputFieldId: {
                kind: 'string',
                required: true
              }
            }
          }
        }
      }
    },
    {
      stepType: PipelineStepType.SAVE_TO_RESULTS,
      isDeprecated: false,
      version: 2,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Saved results': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Rows with errors': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        schemaId: {
          kind: 'string',
          required: true
        },
        columnMapping: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              inputColumnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              outputFieldId: {
                kind: 'string',
                required: true
              }
            }
          }
        },
        targetSpecificMapping: {
          kind: 'shape',
          required: false,
          fields: {
            target: {
              kind: 'enum',
              required: true,
              choices: [
                'TEST_ORDER_TABLE'
              ]
            },
            targetVersion: {
              kind: 'integer',
              required: true,
              minValue: 0,
              maxValue: 0
            },
            columnMappings: {
              kind: 'array',
              required: true,
              elementSpec: {
                kind: 'shape',
                required: true,
                fields: {
                  inputColumnSystemName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  outputColumnSystemName: {
                    kind: 'string',
                    required: true
                  }
                }
              }
            }
          }
        }
      }
    }
  ],
  [PipelineStepType.SEND_TO_CONNECTION]: [
    {
      stepType: PipelineStepType.SEND_TO_CONNECTION,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input file': {
          kind: PipelineStepDataKind.FILE,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {},
      config: {
        connectionId: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.SEND_TO_DOCUMENT]: [
    {
      stepType: PipelineStepType.SEND_TO_DOCUMENT,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input saved results': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        },
        'Input datasets': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        },
        'Input charts': {
          kind: PipelineStepDataKind.CHART,
          isMulti: true,
          isRequired: false
        }
      },
      outputDataShapes: {},
      config: {
        documentId: {
          kind: 'string',
          required: true
        },
        sectionLayout: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              sectionName: {
                kind: 'string',
                required: true
              },
              inputReferences: {
                kind: 'array',
                required: true,
                elementSpec: {
                  kind: 'shape',
                  required: true,
                  fields: {
                    inputDataName: {
                      kind: 'enum',
                      required: true,
                      choices: [
                        'Input saved results',
                        'Input datasets',
                        'Input charts'
                      ]
                    },
                    inputDataIndex: {
                      kind: 'number',
                      required: true
                    }
                  }
                }
              }
            }
          }
        },
        sectionIndex: {
          kind: 'integer',
          required: false
        }
      }
    }
  ],
  [PipelineStepType.SORT_COLUMNS]: [
    {
      stepType: PipelineStepType.SORT_COLUMNS,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        sortOptions: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              column: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              direction: {
                kind: 'enum',
                required: true,
                choices: [
                  'ASCENDING',
                  'DESCENDING'
                ]
              }
            }
          },
          minItems: 1
        }
      }
    }
  ],
  [PipelineStepType.T_TEST]: [
    {
      stepType: PipelineStepType.T_TEST,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        dataFormat: {
          kind: 'taggedUnion',
          required: true,
          tagKey: 'type',
          choices: [
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'LONG'
                },
                labelColumn: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                valueColumn: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                labelsToUse: {
                  kind: 'array',
                  required: false,
                  elementSpec: {
                    kind: 'string',
                    required: true
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'WIDE'
                },
                columns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  minItems: 1
                }
              }
            }
          ]
        },
        tTestType: {
          kind: 'enum',
          required: true,
          choices: [
            'INDEPENDENT',
            'PAIRED',
            'ONE_SAMPLE'
          ]
        },
        alternativeHypothesis: {
          kind: 'enum',
          required: true,
          choices: [
            'TWO_SIDED',
            'LESS_THAN',
            'GREATER_THAN'
          ]
        },
        significanceLevel: {
          kind: 'number',
          required: true
        },
        hypothesisMean: {
          kind: 'number',
          required: false
        }
      }
    }
  ],
  [PipelineStepType.TABLE_VIEW]: [
    {
      stepType: PipelineStepType.TABLE_VIEW,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        viewName: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.TEMPLATE_INPUT]: [
    {
      stepType: PipelineStepType.TEMPLATE_INPUT,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: false
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        dataFrameVariableBinding: {
          kind: 'shape',
          required: false,
          fields: {
            variableId: {
              kind: 'string',
              required: true
            },
            newDataFrameId: {
              kind: 'string',
              required: true
            }
          }
        }
      }
    },
    {
      stepType: PipelineStepType.TEMPLATE_INPUT,
      isDeprecated: false,
      version: 1,
      inputDataShapes: {},
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: null
    }
  ],
  [PipelineStepType.THIRD_PARTY]: [
    {
      stepType: PipelineStepType.THIRD_PARTY,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        }
      },
      outputDataShapes: {
        'Output datasets': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        },
        'Output files': {
          kind: PipelineStepDataKind.FILE,
          isMulti: true,
          isRequired: false
        }
      },
      config: null
    },
    {
      stepType: PipelineStepType.THIRD_PARTY,
      isDeprecated: false,
      version: 1,
      inputDataShapes: {},
      outputDataShapes: {
        'Output datasets': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        },
        'Output files': {
          kind: PipelineStepDataKind.FILE,
          isMulti: true,
          isRequired: false
        }
      },
      config: null
    }
  ],
  [PipelineStepType.UNION_DATASETS]: [
    {
      stepType: PipelineStepType.UNION_DATASETS,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Primary data frame': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        },
        'Secondary data frames': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        dataFrameName: {
          kind: 'string',
          required: true
        },
        primaryDataSourceColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Primary data frame',
            validationOptions: null
          },
          minItems: 1
        },
        secondaryDataSourcesColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'array',
            required: true,
            elementSpec: {
              kind: 'columnReference',
              required: true,
              inputDataName: 'Secondary data frames',
              validationOptions: null
            },
            minItems: 1
          },
          minItems: 1
        },
        includeDuplicates: {
          kind: 'boolean',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.UNPIVOT_DATASET]: [
    {
      stepType: PipelineStepType.UNPIVOT_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        unpivotColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Input dataset',
            validationOptions: null
          },
          minItems: 1
        },
        nameColumn: {
          kind: 'string',
          required: true
        },
        valueColumn: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.UPLOAD_CSV_DATASET]: [
    {
      stepType: PipelineStepType.UPLOAD_CSV_DATASET,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {},
      outputDataShapes: {
        Dataset: {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        dataFrameName: {
          kind: 'string',
          required: true
        },
        fileName: {
          kind: 'string',
          required: true
        },
        s3URL: {
          kind: 'string',
          required: true
        }
      }
    }
  ],
  [PipelineStepType.USER_DEFINED_FUNCTION]: [
    {
      stepType: PipelineStepType.USER_DEFINED_FUNCTION,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input datasets': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        },
        'Input files': {
          kind: PipelineStepDataKind.FILE,
          isMulti: true,
          isRequired: false
        }
      },
      outputDataShapes: {
        'Output datasets': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: true,
          isRequired: false
        },
        'Output files': {
          kind: PipelineStepDataKind.FILE,
          isMulti: true,
          isRequired: false
        }
      },
      config: {
        userDefinedCode: {
          kind: 'string',
          required: true
        },
        params: {
          kind: 'anything',
          required: false
        }
      }
    }
  ],
  [PipelineStepType.WINDOW_FUNCTIONS]: [
    {
      stepType: PipelineStepType.WINDOW_FUNCTIONS,
      isDeprecated: false,
      version: 0,
      inputDataShapes: {
        'Input dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      outputDataShapes: {
        'Output dataset': {
          kind: PipelineStepDataKind.DATASET,
          isMulti: false,
          isRequired: true
        }
      },
      config: {
        windows: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'taggedUnion',
            required: true,
            tagKey: 'aggregationFunction',
            choices: [
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'AVERAGE'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'COUNT'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'COUNT_NULLS'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'MAX'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'MEDIAN'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'MIN'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'MODE'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'PRODUCT'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'STANDARD_DEVIATION'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'STANDARD_ERROR'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'SUM'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'VARIANCE'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: {
                      allowedLeafTypes: [
                        LeafType.INTEGER,
                        LeafType.DECIMAL
                      ]
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'FIRST'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'LAG'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'LAST'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'LEAD'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  },
                  column: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'CUME_DIST'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'DENSE_RANK'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'PERCENT_RANK'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'RANK'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  aggregationFunction: {
                    kind: 'string',
                    required: true,
                    value: 'ROW_NUMBER'
                  },
                  newColumnName: {
                    kind: 'string',
                    required: true
                  },
                  partitionColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'columnReference',
                      required: true,
                      inputDataName: 'Input dataset',
                      validationOptions: null
                    }
                  },
                  orderByColumns: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        column: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        direction: {
                          kind: 'enum',
                          required: true,
                          choices: [
                            'ASCENDING',
                            'DESCENDING'
                          ]
                        }
                      }
                    }
                  }
                }
              }
            ]
          },
          minItems: 1
        },
        orderByColumns: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'shape',
            required: true,
            fields: {
              column: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              direction: {
                kind: 'enum',
                required: true,
                choices: [
                  'ASCENDING',
                  'DESCENDING'
                ]
              }
            }
          }
        }
      }
    }
  ]
} as const satisfies Record<PipelineStepType, ReadonlyArray<PipelineStepShape>>;
